import { useQuery } from "@apollo/client";
import { GET_POLLS } from "./graphql";
import {
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import React from "react";
import { LinkButton } from "../../components/LinkButton";
import { PageContainer } from "../../components/PageContainer";
import { LoadingOverlay } from "../../components/Loading";

const Polls = () => {
  const [page, setPage] = React.useState(1);
  const [search, setSearch] = React.useState("");

  const { data, error, loading } = useQuery(GET_POLLS);

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  return (
    <PageContainer title="Polls">
      <LinkButton
        path="/poll/edit/new"
        text="Create new poll"
        variant={"contained"}
        style={{ marginBottom: 8 }}
      />
      <LoadingOverlay loading={loading}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Title</TableCell>
                <TableCell align="left">Expiry Date</TableCell>
                <TableCell align="left">actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.polls.map((row) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="left">{row.title}</TableCell>
                  <TableCell align="left">{row.expiryDate}</TableCell>
                  <TableCell align="left">
                    <LinkButton path={`/poll/edit/${row.id}`} text="View" />
                    <LinkButton path={`/poll/result/${row.id}`} text="View Result" />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </LoadingOverlay>
    </PageContainer>
  );
};

export default Polls;
